export const groups = ['stora', 'lattskotta', 'halvskugga', 'ljust', 'medkruka', 'paket'];
export const categoryFilters = { green: { keys: groups, multiple: true }, bulbs: { keys: ['tulpan', 'narciss', 'krokus', 'ranunkel', 'ovriga-lokar'], multiple: false }, artificial: { keys: ['stora', 'kompakta'], multiple: false } };

export const decorKinds = ['krukor', 'krukkorgar', 'vaxtpasar', 'vaser', 'ljusstakar', 'ovrigt'];
export const decorColors = {
  svart: ['svart', 'mattsvart'], vit: ['vit', 'blåvitt'], bla: ['blå', 'blåvitt', 'vintageblå'],
  gron: ['grön', 'bladgrön'], gul: ['gul', 'bärnstensgul', 'ockra'], rosa: ['rosa', 'vintagerosa', 'pink'],
  rod: ['röd', 'vinröd'], lila: ['lila', 'lavendellila'], gra: ['grå', 'blygrå', 'antracit'],
  brun: ['brun', 'ljusbrun'], beige: ['beige', 'taupe'], guld: ['guld'], brons: ['bronsfärgad'], natur: ['natur']
};
categoryFilters.decor = { keys: [...decorKinds.map(k => 'kind:' + k), ...Object.keys(decorColors).map(k => 'color:' + k), 'color:flerfargad', 'color:ej-angiven', 'price:under300', 'price:300-600', 'price:600plus'], multiple: true };

export function classifyDecor(product) {
  const title = String(product.title || '').toLocaleLowerCase('sv').normalize('NFKC');
  const words = title.match(/\p{L}+/gu) || [];
  const kind = /ljusstake/.test(title) ? 'ljusstakar' : /dekorationsvas|\bvas\b/.test(title) ? 'vaser' : /krukkorg/.test(title) ? 'krukkorgar' : /växtpåse/.test(title) ? 'vaxtpasar' : /ytterkruka|dekorationskruka/.test(title) ? 'krukor' : 'ovrigt';
  const colors = Object.entries(decorColors).filter(([, tokens]) => tokens.some(token => words.includes(token))).map(([key]) => 'color:' + key);
  if (words.includes('flerfärgad') || colors.length > 1) colors.push('color:flerfargad');
  if (!colors.length) colors.push('color:ej-angiven');
  const price = typeof product.price === 'number' && Number.isFinite(product.price) && product.price >= 0 ? ['price:' + (product.price < 30000 ? 'under300' : product.price < 60000 ? '300-600' : '600plus')] : [];
  return ['kind:' + kind, ...colors, ...price];
}


export function classify(product, mode = 'green') {
  if (mode === 'decor') return classifyDecor(product);
  if (mode === 'bulbs') {
    const type = String(product.type || '').toLocaleLowerCase('sv');
    const known = ['tulpan', 'narciss', 'krokus', 'ranunkel'].find(key => type.includes(key));
    return known ? [known] : (/blomsterlökar/.test(type) ? ['ovriga-lokar'] : []);
  }
  if (mode === 'artificial') {
    const explicit = String(product.title || '').match(/[–—-]\s*(\d+(?:[,.]\d+)?)\s*cm\s*$/);
    const cm = explicit ? Number(explicit[1].replace(',', '.')) : Number(product.height);
    return cm > 0 ? [cm >= 80 ? 'stora' : 'kompakta'] : [];
  }
  const title = String(product.title || '').toLocaleLowerCase('sv');
  const text = String(product.description || '').toLocaleLowerCase('sv');
  if (/konstgjord|lökar|knölar/.test(String(product.type || '').toLocaleLowerCase('sv'))) return [];
  const height = title.match(/höjd\s*(?:ca\.?\s*)?(\d+(?:[,.]\d+)?)\s*(?:[–—-]\s*\d+(?:[,.]\d+)?)?\s*(cm|m)\b/);
  const cm = height ? Number(height[1].replace(',', '.')) * (height[2] === 'm' ? 100 : 1) : 0;
  const result = [];
  if (cm >= 80) result.push('stora');
  if (/lättskött|små skötselkrav|låga skötselkrav/.test(text) && !/(?:inte|ej)\s+(?:en\s+)?lättskött/.test(text)) result.push('lattskotta');
  if (/halvskugga|halvskuggig/.test(text) && !/(?:undvik|inte i|ej i)\s+halvskugga/.test(text)) result.push('halvskugga');
  if (/indirekt (?:dags)?ljus|ljust utan|ljust[, ]+(?:men )?undvik|ljust[^.!?]{0,180}(?:undvik|skydd)[^.!?]{0,80}direkt sol/.test(text)) result.push('ljust');
  if (/(?:ytterkruka|keramikkruka|korg)/.test(title) && !/utan[^–—,]*(?:ytterkruka|keramikkruka|korg)/.test(title)) result.push('medkruka');
  if (/\b(?:[2-9]|\d{2,})\s*[- ]?(?:pack|växter|plantor)\b|växtpaket\b/.test(title) || (product.tags || []).includes('växtpaket')) result.push('paket');
  return result;
}

export function matches(product, selected = [], available = false) {
  if (product.catalogMode === 'decor') {
    const facets = [...new Set(selected.map(key => key.split(':')[0]))];
    return (!available || product.available) && facets.every(facet => selected.filter(key => key.startsWith(facet + ':')).some(key => product.groups.includes(key)));
  }
  return (!available || product.available) && selected.every(key => product.groups.includes(key));
}

export function facetCounts(products, selected = [], available = false, keys = groups, multiple = true) {
  return Object.fromEntries([
    ['all', products.filter(p => matches(p, [], available)).length],
    ...keys.map(key => [key, products.filter(p => matches(p, key.includes(':') ? [...selected.filter(s => s.split(':')[0] !== key.split(':')[0]), key] : multiple ? [...new Set([...selected, key])] : [key], available)).length]),
    ['available', products.filter(p => matches(p, selected, true)).length]
  ]);
}

export function sortedMatches(products, selected, available, sort) {
  const result = products.filter(p => matches(p, selected, available));
  const sorts = {
    'price-ascending': (a, b) => a.price - b.price,
    'price-descending': (a, b) => b.price - a.price,
    'title-ascending': (a, b) => a.title.localeCompare(b.title, 'sv'),
    'title-descending': (a, b) => b.title.localeCompare(a.title, 'sv'),
    'created-descending': (a, b) => Number(b.created) - Number(a.created)
  };
  if (sorts[sort]) result.sort(sorts[sort]);
  return result;
}

async function init(root) {
  const text = JSON.parse(root.querySelector('[data-gc-text]').textContent);
  const summary = root.querySelector('[data-gc-summary]');
  const grid = root.querySelector('[data-gc-grid]');
  const pages = root.querySelector('[data-gc-pages]');
  const status = root.querySelector('[data-gc-status]');
  const dialog = root.querySelector('[data-gc-dialog]');
  const pageSize = Math.max(1, Number(root.dataset.pageSize));
  const mode = root.dataset.catalogMode || 'green';
  const { keys, multiple } = categoryFilters[mode] || categoryFilters.green;
  let products = null;
  let loading = false;
  let selected = [];
  let available = false;
  let sort = 'manual';
  let page = 1;
  const say = (key, values = {}) => Object.entries(values).reduce((s, [k, v]) => s.replaceAll('__' + k.toUpperCase() + '__', String(v)), text[key]);

  function readState() {
    const params = new URL(location.href).searchParams;
    const legacyPackage = root.dataset.initialFilter && location.pathname !== root.dataset.source;
    const initial = legacyPackage ? root.dataset.initialFilter : root.dataset.initialView.replace('growth-', '');
    selected = params.has('g_filters') ? params.get('g_filters').split(',').filter(k => keys.includes(k)) : (keys.includes(initial) && (legacyPackage || params.get('view')?.startsWith('growth-')) ? [initial] : []);
    selected = [...new Set(selected)];
    if (!multiple) selected = selected.slice(0, 1);
    available = params.get('available') === '1';
    const candidate = params.get('sort_by') || (mode === 'decor' ? root.dataset.defaultSort : '') || 'manual';
    sort = [...root.querySelector('[data-gc-sort]').options].some(o => o.value === candidate) ? candidate : 'manual';
    page = Math.max(1, Number.parseInt(params.get('page'), 10) || 1);
  }

  function stateURL(p = page) {
    const url = new URL(location.href);
    if (root.dataset.initialFilter && url.pathname !== root.dataset.source) url.pathname = root.dataset.source;
    if (keys.includes((url.searchParams.get('view') || '').replace('growth-', ''))) url.searchParams.delete('view');
    if (selected.length) url.searchParams.set('g_filters', selected.join(',')); else url.searchParams.delete('g_filters');
    if (available) url.searchParams.set('available', '1'); else url.searchParams.delete('available');
    if (sort !== 'manual') url.searchParams.set('sort_by', sort); else url.searchParams.delete('sort_by');
    if (p > 1) url.searchParams.set('page', String(p)); else url.searchParams.delete('page');
    return url;
  }

  function render(push = false) {
    const result = sortedMatches(products, selected, available, sort);
    const pageCount = Math.max(1, Math.ceil(result.length / pageSize));
    page = Math.min(page, pageCount);
    const shown = result.slice((page - 1) * pageSize, page * pageSize);
    const counts = facetCounts(products, selected, available, keys, multiple);
    root.querySelector('[data-gc-unavailable]').hidden = products.some(p => p.available);
    root.querySelectorAll('[data-gc-count]').forEach(el => { el.textContent = '(' + counts[el.dataset.gcCount] + ')'; });
    root.querySelectorAll('[data-gc-filter]').forEach(input => {
      if (mode === 'decor') input.closest('label').hidden = !products.some(p => p.groups.includes(input.value));
      input.checked = selected.includes(input.value);
      input.disabled = !input.checked && counts[input.value] === 0;
    });
    root.querySelectorAll('[data-gc-stock]').forEach(input => { input.checked = available; input.disabled = !available && counts.available === 0; });
    root.querySelectorAll('[data-gc-all]').forEach(button => { button.disabled = false; button.setAttribute('aria-pressed', String(selected.length === 0)); });
    root.querySelectorAll('[data-gc-reset],[data-gc-sort]').forEach(el => { el.disabled = false; });
    root.querySelector('[data-gc-sort]').value = sort;
    const apply = root.querySelector('.gc-apply');
    apply.disabled = false;
    apply.textContent = say('show', { total: result.length });
    summary.textContent = say('summary', { shown: shown.length, total: result.length });
    grid.replaceChildren();
    if (!shown.length) {
      const message = document.createElement('p'); message.className = 'gc-empty'; message.textContent = text.empty; grid.append(message);
    }
    for (const product of shown) {
      const tile = document.createElement('div'); tile.dataset.gcProduct = product.id; tile.innerHTML = product.html;
      tile.querySelectorAll('img.lazyload[data-src]').forEach(img => { img.loading = 'lazy'; img.src = img.dataset.src; img.classList.remove('lazyload'); });
      grid.append(tile);
    }
    pages.replaceChildren();
    const visiblePages = new Set([1, pageCount, page - 1, page, page + 1].filter(p => p > 0 && p <= pageCount));
    function link(p, label, current = false) {
      const a = document.createElement('a'); a.href = stateURL(p).href; a.dataset.gcPage = p; a.textContent = label;
      if (current) a.setAttribute('aria-current', 'page');
      pages.append(a);
    }
    if (pageCount > 1) {
      if (page > 1) link(page - 1, '←');
      let previous = 0;
      [...visiblePages].sort((a, b) => a - b).forEach(p => { if (p - previous > 1) { const gap = document.createElement('span'); gap.textContent = '…'; pages.append(gap); } link(p, String(p), p === page); previous = p; });
      if (page < pageCount) link(page + 1, '→');
    }
    if (push) history.pushState({}, '', stateURL());
    else history.replaceState({}, '', stateURL());
    status.hidden = true;
  }

  async function load() {
    if (loading || products) return;
    loading = true; status.hidden = false; status.textContent = text.loading;
    root.querySelector('[data-gc-retry]').hidden = true;
    try {
      let next = new URL(root.dataset.source, location.origin);
      next.searchParams.set('view', 'growth-data');
      const seen = new Set(); const all = []; let total = null;
      while (next) {
        if (next.origin !== location.origin || seen.has(next.href)) throw new Error('Invalid pagination');
        seen.add(next.href);
        const response = await fetch(next, { credentials: 'same-origin', cache: 'no-cache', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Catalogue HTTP ' + response.status);
        const data = await response.json();
        if (!Number.isInteger(data.total) || !Array.isArray(data.products) || (total !== null && total !== data.total)) throw new Error('Invalid catalogue page: ' + JSON.stringify({ total: data.total, previousTotal: total, productsArray: Array.isArray(data.products), keys: Object.keys(data) }));
        total = data.total; all.push(...data.products);
        next = data.next ? new URL(data.next, location.origin) : null;
        if (next) next.searchParams.set('view', 'growth-data');
      }
      if (all.length !== total || new Set(all.map(p => p.id)).size !== total) throw new Error('Incomplete catalogue');
      products = all.map(p => ({ ...p, catalogMode: mode, groups: classify(p, mode) }));
      readState(); render();
    } catch (error) {
      root.querySelectorAll('[data-gc-count]').forEach(el => { el.textContent = '(–)'; });
      status.textContent = text.error; root.querySelector('[data-gc-retry]').hidden = false;
      console.error('Bringners catalogue:', error.message);
    } finally { loading = false; }
  }

  root.addEventListener('change', event => {
    if (!products) return;
    const el = event.target;
    if (el.matches('[data-gc-filter]')) selected = el.checked ? (multiple ? [...new Set([...selected, el.value])] : [el.value]) : selected.filter(k => k !== el.value);
    else if (el.matches('[data-gc-stock]')) available = el.checked;
    else if (el.matches('[data-gc-sort]')) sort = el.value;
    else return;
    page = 1; render(true);
  });
  root.addEventListener('click', event => {
    const el = event.target.closest('button,a'); if (!el) return;
    if (el.matches('[data-gc-open]')) { dialog.showModal(); return; }
    if (el.matches('[data-gc-close]')) { dialog.close(); return; }
    if (el.matches('[data-gc-retry]')) { load(); return; }
    if (!products) return;
    if (el.matches('[data-gc-reset],[data-gc-all]')) { selected = []; if (el.matches('[data-gc-reset]')) available = false; page = 1; render(true); }
    if (el.matches('[data-gc-page]') && !event.metaKey && !event.ctrlKey && !event.shiftKey) { event.preventDefault(); page = Number(el.dataset.gcPage); render(true); summary.scrollIntoView({ block: 'start' }); }
  });
  dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX > dialog.getBoundingClientRect().right) dialog.close(); });
  window.addEventListener('popstate', () => { if (products) { readState(); render(); } });
  await load();
}

if (typeof document !== 'undefined') document.querySelectorAll('[data-green-catalog]').forEach(init);
